import { render, staticRenderFns } from "./ExportActivities.vue?vue&type=template&id=f581ae7a&"
import script from "./ExportActivities.vue?vue&type=script&lang=js&"
export * from "./ExportActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports